<template>
    <div :class="['RelatedFilter', variantClass]">
        <div
            class="ItemMainContainer"
            @click="$emit(item.pinned ? 'unpin' : 'pin', item)"
        >
            <WIcon
                :icon="item.pinned ? 'pin' : 'pin-outline'"
                :color="!item.pinned || excluded ? 'grayLight' : 'white'"
                class="PinIcon"
                :size="18"
            />
            <WText
                :color="item.pinned ? 'white' : 'gray02'"
                :size="12"
            >
                {{ entityLabel }}
            </WText>
            <WText
                :class="['RelatedField', variantClass]"
                :color="item.pinned ? 'white' : 'gray02'"
                weight="bold"
                :size="14"
            >
                {{ fieldLabel }}
            </WText>
            <div :class="['FiltersQty', variantClass]">
                <WText
                    weight="bold"
                    :color="item.pinned ? excluded ? 'gray04' : entityColor : 'white'"
                    :size="12"
                >
                    {{ item.filtersQty }}
                </WText>
            </div>
        </div>
        <div
            :class="['ItemCloseContainer', variantClass] "
            @click="$emit('removeFilter', item)"
        >
            <WIcon
                icon="close"
                :color="item.pinned && !excluded ? entityColor : 'white'"
                :size="18"
            />
        </div>
        <WIcon
            v-if="excluded"
            v-tooltip="{ content: $t('filters.excluded'), placement: 'top' }"
            icon="alert-circle"
            color="grayMedium"
            class="InfoIcon"
            :size="18"
        />
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { ENTITIES_BY_ID } from '@/entities/entities'
import formatToCaseText from '@/utils/formatToCaseText'

export default {
    name: 'RelatedFilterItem',
    props: {
        item: VueTypes.object,
        excluded: VueTypes.bool,
    },
    computed: {
        entityColor () {
            return ENTITIES_BY_ID[this.item.entity].color
        },
        fieldLabel () {
            return formatToCaseText(this.item.field)
        },
        entityLabel () {
            return ENTITIES_BY_ID[this.item.entity].label
        },
        variantClass () {
            const { item, excluded, entityColor } = this
            return { pinned: item.pinned, excluded, [`entity-${entityColor}`]: !excluded }
        },
    },
}
</script>

<style lang="scss" scoped>
.RelatedFilter {
    display: flex;
    border-radius: $border-radius;
    border: 1px solid $primary;
    flex-shrink: 0;
    position: relative;
    &.entity-turquoise {
        border-color: $turquoise;
        &.pinned {
            background-color: $turquoise;
        }
    }
    &.entity-cyan {
        border-color: $cyan;
        &.pinned {
            background-color: $cyan;
        }
    }
    &.entity-violet {
        border-color: $violet;
        &.pinned {
            background-color: $violet;
        }
    }
    &.entity-pink {
        border-color: $pink;
        &.pinned {
            background-color: $pink;
        }
    }
    &.excluded {
        border-color: $gray-02;
        background-color: $gray-06;
        &.pinned {
            background-color: $gray-04;
        }
    }
    .ItemMainContainer {
        cursor: pointer;
        padding: 6px;
        display: flex;
        align-items: center;
        .RelatedField {
            border-left: 1px solid $primary;
            margin-left: 6px;
            margin-right: 6px;
            padding-left: 6px;
            border-color: $gray-02;
            &.entity-turquoise {
                border-color: $turquoise;
            }
            &.entity-cyan {
                border-color: $cyan;
            }
            &.entity-violet {
                border-color: $violet;
            }
            &.entity-pink {
                border-color: $pink;
            }
            &.pinned {
                border-color: $white;
            }
        }
        .FiltersQty {
            background-color: $gray-03;
            border-radius: 100%;
            margin-right: 4px;
            width: 15px;
            height: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            &.entity-turquoise {
                background-color: $turquoise;
            }
            &.entity-cyan {
                background-color: $cyan;
            }
            &.entity-violet {
                background-color: $violet;
            }
            &.entity-pink {
                background-color: $pink;
            }
            &.pinned {
                background-color: $white;
            }
        }
        .PinIcon {
            margin-right: 6px;
        }
    }
    .ItemCloseContainer {
        cursor: pointer;
        background-color: $accent-blue;
        display: flex;
        padding: 6px;
        align-items: center;
        justify-content: center;
        border-top-right-radius: $border-radius - 1;
        border-bottom-right-radius: $border-radius;
        &.entity-turquoise {
            background-color: $turquoise;
        }
        &.entity-cyan {
            background-color: $cyan;
        }
        &.entity-violet {
            background-color: $violet;
        }
        &.entity-pink {
            background-color: $pink;
        }
        &.pinned {
            background-color: white;
        }
        &.excluded {
            background-color: $gray-02;
        }
    }
    .InfoIcon {
        background-color: $white;
        position: absolute;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 1px;
        top: -7px;
        left: -7px;
    }
}
</style>
